import {
    SUCCESS_GET_BOK_1_HEADERS,
    FAILED_GET_BOK_1_HEADERS,
    SUCCESS_GET_BOK_2_LINES,
    FAILED_GET_BOK_2_LINES,
    RESET_GET_BOK_2_LINES,
    SUCCESS_GET_BOK_3_LINES_DATA,
    FAILED_GET_BOK_3_LINES_DATA,
    RESET_GET_BOK_3_LINES_DATA,
    SUCCESS_GET_BOK_WITH_PRICINGS,
    FAILED_GET_BOK_WITH_PRICINGS,
    SUCCESS_SELECT_PRICING,
    FAILED_SELECT_PRICING,
    SET_NEED_TO_UPDATE_PRICINGS,
    RESET_NEED_TO_UPDATE_PRICINGS,
    SUCCESS_GET_DE_STATUS,
    FAILED_GET_DE_STATUS,
    SUCCESS_BOOK_FREIGHT,
    FAILED_BOOK_FREIGHT,
    SUCCESS_CANCEL_FREIGHT,
    FAILED_CANCEL_FREIGHT,
    SUCCESS_UPDATE_BOK_1,
    FAILED_UPDATE_BOK_1,
    SUCCESS_ADD_BOK_LINE,
    FAILED_ADD_BOK_LINE,
    SUCCESS_UPDATE_BOK_LINE,
    FAILED_UPDATE_BOK_LINE,
    SUCCESS_DELETE_BOK_LINE,
    FAILED_DELETE_BOK_LINE,
    SUCCESS_BOK_REPACK,
    FAILED_BOK_REPACK,
    REQUEST_BOK_ORDERS_STATUS,
    SUCCESS_BOK_ORDERS_STATUS,
    FAILED_BOK_ORDERS_STATUS,
} from '../constants/bokConstants';

const defaultState = {
    BOK_1_headers: [],
    BOK_2_lines: [],
    BOK_3_lines_data: [],
    BOK_with_pricings: null,
    needToUpdatePricings: null,
    errorMessage: '',
    // Which of get_delivery_status's three failure modes the server named:
    // bad_request, not_found or our_fault. Null when we have not been told,
    // which is not the same as any of the three and must not be rendered as one.
    deStatusOutcome: null,
    deliveryStep: null,
    deliveryStatus: null,
    clientLogoUrl: '',
    quote: null,
    booking: null,
    loadSuccess: null,
    bookedSuccess: null,
    canceledSuccess: null,
    selectPricingSuccess: null,
    repackSuccess: null,
    lineOperationSuccess: null,
    lastUpdated: null,
    originalLines: [],
    packedLines: [],
    scans: [],
    pods: [],
    ssccHistory: [],
    ordersStatus: {
        date: null,
        count: 0,
        results: [],
    },
    ordersStatusLoading: false,
    ordersStatusError: null,
};

export const BokReducer = (state = defaultState, { type, payload, outcome, errorMessage }) => {
    switch (type) {
        case SET_NEED_TO_UPDATE_PRICINGS:
            return {
                ...state,
                needToUpdatePricings: true,
            };
        case RESET_NEED_TO_UPDATE_PRICINGS:
            return {
                ...state,
                needToUpdatePricings: false,
                loadSuccess: null,
                bookedSuccess: null,
                canceledSuccess: null,
                selectPricingSuccess: null,
                repackSuccess: null,
                lineOperationSuccess: null,
            };
        case RESET_GET_BOK_2_LINES:
            return {
                ...state,
                BOK_2_lines: [],
            };
        case RESET_GET_BOK_3_LINES_DATA:
            return {
                ...state,
                BOK_3_lines_data: [],
            };
        case SUCCESS_GET_BOK_1_HEADERS:
            return {
                ...state,
                BOK_1_headers: payload,
            };
        case SUCCESS_GET_BOK_2_LINES:
            return {
                ...state,
                BOK_2_lines: payload,
            };
        case SUCCESS_GET_BOK_3_LINES_DATA:
            return {
                ...state,
                BOK_3_lines_data: payload,
            };
        case SUCCESS_GET_BOK_WITH_PRICINGS:
            return {
                ...state,
                loadSuccess: true,
                BOK_with_pricings: payload,
            };
        case SUCCESS_UPDATE_BOK_1:
        case SUCCESS_SELECT_PRICING:
            return {
                ...state,
                needToUpdatePricings: true,
                selectPricingSuccess: true,
            };
        case SUCCESS_GET_DE_STATUS:
            return {
                ...state,
                deliveryStatus: payload.status,
                deliveryStep: payload.step,
                clientLogoUrl: payload.logo_url,
                quote: payload.quote,
                booking: payload.booking,
                lastUpdated: payload.last_updated,
                originalLines: payload.original_lines,
                packedLines: payload.packed_lines,
                pods: payload.pods,
                apls: payload.apls,
                ssccHistory: payload.sscc_history,
                etaDate: payload.eta_date,
                lastMilestone: payload.last_milestone,
                timestamps: payload.timestamps,
                scans: payload.scans
            };
        case SUCCESS_BOOK_FREIGHT:
            return {
                ...state,
                bookedSuccess: true,
            };
        case SUCCESS_CANCEL_FREIGHT:
            return {
                ...state,
                canceledSuccess: true,
            };
        case SUCCESS_BOK_REPACK:
            return {
                ...state,
                repackSuccess: true,
            };
        case SUCCESS_ADD_BOK_LINE:
        case SUCCESS_UPDATE_BOK_LINE:
        case SUCCESS_DELETE_BOK_LINE:
            return {
                ...state,
                lineOperationSuccess: true,
            };
        // Its own case only because it carries one extra field. `errorMessage`
        // is set exactly as the shared branch below sets it. `deStatusOutcome`
        // is the server naming which of its three failure modes this was, so
        // the page can say the true thing without issuing a second request
        // purely to read the status code.
        case FAILED_GET_DE_STATUS:
            return {
                ...state,
                errorMessage: payload,
                deStatusOutcome: outcome || null,
                needToUpdatePricings: false,
            };

        case REQUEST_BOK_ORDERS_STATUS:
            return {
                ...state,
                ordersStatusLoading: true,
                ordersStatusError: null,
            };

        case SUCCESS_BOK_ORDERS_STATUS:
            return {
                ...state,
                ordersStatusLoading: false,
                ordersStatus: payload,
                ordersStatusError: null,
            };

        case FAILED_BOK_ORDERS_STATUS:
            return {
                ...state,
                ordersStatusLoading: false,
                ordersStatusError: errorMessage,
            };

        case FAILED_SELECT_PRICING:
        case FAILED_GET_BOK_1_HEADERS:
        case FAILED_GET_BOK_2_LINES:
        case FAILED_GET_BOK_3_LINES_DATA:
        case FAILED_GET_BOK_WITH_PRICINGS:
        case FAILED_BOOK_FREIGHT:
        case FAILED_CANCEL_FREIGHT:
        case FAILED_UPDATE_BOK_1:
        case FAILED_BOK_REPACK:
        case FAILED_ADD_BOK_LINE:
        case FAILED_UPDATE_BOK_LINE:
        case FAILED_DELETE_BOK_LINE:
            return {
                ...state,
                errorMessage: payload,
                needToUpdatePricings: false,
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// src/state/reducers/bokReducer.js